import React from 'react';

const BestMatch = ({
  color = 'var(--color-primary)',
  width = 21,
  height = 20,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 21 20"
  >
    <g
      fill="none"
      fillRule="evenodd"
      stroke={color}
      strokeWidth="1.4"
      transform="translate(1 1)"
    >
      <circle cx="5.517" cy="5.517" r="5.517" />
      <path strokeLinejoin="round" d="M9.336 9.336L10.609 10.609" />
      <path d="M11.535 10.287l6.716 6.486c.337.326.347.863.021 1.2-.326.337-.863.347-1.2.021l-6.716-6.485h0l1.18-1.222z" />
    </g>
  </svg>
);

export default BestMatch;
